import { Injectable } from '@angular/core';
import { ParamMap } from '@angular/router';
import { Customer } from '../../shared/interfaces/customer';

type PurlFields = Pick<Customer, 'firstName' | 'lastName'>;

@Injectable({
    providedIn: 'root',
})
export class PurlParamsService {

    private static readonly PARAM_MAP: Record<string, keyof PurlFields> = {
        fname: 'firstName',
        lname: 'lastName',
    };

    private parsed: Partial<PurlFields> = {};

    public getParams(): Partial<PurlFields> {
        return this.parsed;
    }

    public parseFromQueryParams(queryParamMap: ParamMap): void {
        const result: Partial<PurlFields> = {};
        for (const [queryKey, field] of Object.entries(PurlParamsService.PARAM_MAP)) {
            const value = queryParamMap.get(queryKey);
            if (value) {
                result[field] = value;
            }
        }
        this.parsed = result;
    }
}
